const snacks = [];
snacks.push("cracker",
"popcorn");

export default snacks;
